import { gql } from '@apollo/client';

export const TOGGLE_DEACTIVATED_MUTATION = gql`
  mutation ToggleDeactivate($projectId: String!, $isDeactivated: Boolean!) {
    project {
      toggleDeactivate(projectId: $projectId, isDeactivated: $isDeactivated)
    }
  }
`;
